export class MensagemPaginaErro {

    static mensagemRetornoPaginaErro(idErro: string) {
        switch (idErro) {
            case '2001':
                return MensagensEnum.MENSAGEM_ERR_PROTOCOLO;
            case '2002':
                return MensagensEnum.MENSAGEM_ERR_IAM;
            case '2003':
                return MensagensEnum.MENSAGEM_ERR_LOGIN;
            case '2004':
                return MensagensEnum.MENSAGEM_ERR_REL_SINTETICO;
            default:
                return MensagensEnum.MENSAGEM_ERR_PADRAO;
        }
    }

}


enum MensagensEnum {
    MENSAGEM_ERR_PROTOCOLO = '#2001 - Não foi possível exibir suas informações no momento. Por favor, tente novamente mais tarde',
    MENSAGEM_ERR_IAM = '#2002 - Ocorreu um erro referente a autenticacão. Por favor, tente novamente mais tarde',
    MENSAGEM_ERR_LOGIN = '#2003 - Ocorreu um erro referente a autenticacão. Por favor, tente novamente mais tarde',
    MENSAGEM_ERR_REL_SINTETICO = '#2004 - Tempo máximo excedido para obter suas informações! Por favor, tente novamente mais tarde',
    MENSAGEM_ERR_PADRAO = 'Erro ao carregar dados'
}
